jQuery(document).unbind("click").on("click", "#loadmore", function(){ 
	
	var page = jQuery( this ).data('page');
	
	page = parseInt(page) + 1;
		
	jQuery('#loadmore').data( 'page', page );
	
    new_search();
	
});


jQuery('#services input, #expertise input, #verified_only').click(function() {
	
	jQuery('#loadmore').data( 'page', 1 );
	
	new_search();
		
});


jQuery('#sort').on('change', function() {
	
	jQuery('#loadmore').data( 'page', 1 );
	
	new_search();
		
});


jQuery('.edit-review').click(function() {
	
	jQuery(this).parent().parent().parent().addClass('edit-mode');
			
});

jQuery(document).on('gform_confirmation_loaded', function(event, formId){
    
    if(formId == 3) {
	    
       location.reload();
                
    }
            
});

jQuery('.edit-profile').click(function() {
	
	if( jQuery(this).hasClass('edit-mode') ) {
		
		//jQuery('.profile').removeClass('edit-mode');
		
		//jQuery(this).removeClass('edit-mode');
		
		//jQuery(this).text('Edit Profile');
		
		jQuery('.acf-form-submit input').click();
		
	}
	
	else {
		
		jQuery('.profile').addClass('edit-mode');
		
		jQuery('.contact-widget').addClass('edit-mode');
		
		jQuery(this).addClass('edit-mode');
		
		jQuery(this).text('Save Changes');
		
	}
			
});


jQuery('.delete-review').click(function() {
	
	if( confirm( 'Are you sure you want to delete this review?' ) ) {
		
    	var listing = jQuery(this).data('listing');
		var row = jQuery(this).data('row');
	
		deletereivew( listing, row );
    
	}
	
	else {
        return false;
    }
	
});







